<section class="section-div">
  <div class="content-details">
    <div class="container-fluid">
      <div class="title-details">
        <div class="d-flex">
          <h4><ion-icon name="calendar-outline"></ion-icon> Incubator List</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-6">
          <div class="ml-auto">
            <mat-form-field appearance="standard" class="material-full-width">
              <mat-label>Search By Incubator Name</mat-label>
              <mat-icon matPrefix>search</mat-icon>
              <input
                matInput
                (keyup)="applySearch($event)"
                placeholder="Search By Incubator Name"
                #input
                [value]="searchValue"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="offset-1 col-lg-3 col-md-3">
          <form action="" [formGroup]="formValue">
            <div class="form-rows">
              <mat-form-field class="material-full-width" appearance="outline">
                <mat-label>Profile Updated</mat-label>
                <mat-select
                  (selectionChange)="onSelect($event.value)"
                  formControlName="type"
                >
                  <mat-option value="0">All</mat-option>
                  <mat-option value="1">YES</mat-option>
                  <mat-option value="2">NO</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </form>
        </div>
        <div class="mt-3 col-lg-2 col-md-2" *ngIf="noData == false">
          <div class="download-div">
            <button mat-raised-button color="accent" (click)="downloadExcel()">
              TNIMM Export <i class="far fa-file-excel"></i>
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="noData == false">
        <div class="example-container mat-elevation-z8">
          <mat-table
            #table
            [dataSource]="dataSource"
            [class.isMobile]="isMobile"
          >
            <ng-container matColumnDef="index">
              <mat-header-cell *matHeaderCellDef class="max-width">
                No.
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element; let i = index"
                class="max-width"
              >
                <span class="mobile-label">No :</span>
                {{
                  (this.pageNumberSession - 1) * this.pageSizeSession + i + 1
                }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="incubatorName">
              <mat-header-cell *matHeaderCellDef>Name </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="mobile-label">Name :</span>
                <a
                  class="c-blue"
                  (click)="
                    incubaName(element.incubatorId, element.incubatorName)
                  "
                >
                  {{ element.incubatorName }}
                </a>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="profileRegistered">
              <mat-header-cell *matHeaderCellDef class="max-width3">
                Is Profile Updated
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="max-width3">
                <span class="mobile-label">Is Profile Updated :</span>
                <span
                  class="ml-lg-4"
                  [ngClass]="{
                    'text-green': element.profileRegistered === 'Yes',
                    'text-red': element.profileRegistered === 'No'
                  }"
                >
                  {{ element.profileRegistered }}
                </span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="scoreGenerated">
              <mat-header-cell *matHeaderCellDef class="max-width2">
                Is Score Generated
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="max-width2">
                <span class="mobile-label">Is Score Generated :</span>
                <span
                  class="reg-span ml-lg-4"
                  [style.background]="pickBgColor(element.scoreGenerated)"
                  >{{ element.scoreGenerated }}
                </span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Action">
              <mat-header-cell *matHeaderCellDef class="max-width4">
                Action
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="max-width4">
                <span class="mobile-label">Action :</span>

                <button
                  class="profile-edit-btn"
                  (click)="profileGet(element.incubatorId)"
                >
                  <span class="pen-icon">
                    <i class="fas fa-pen"></i>
                  </span>
                  Profile Edit
                </button>
              </mat-cell>
            </ng-container>
            <mat-header-row
              *matHeaderRowDef="displayedColumns"
            ></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>
        </div>

        <mat-paginator
          #paginator
          class="mat-elevation-z8"
          [length]="pageTotalCount"
          [pageSize]="pageSizeSession"
          [pageSizeOptions]="[25, 50, 75, 100]"
          showFirstLastButtons
          (page)="getServerData($event)"
          aria-label="Select page of periodic elements"
        >
        </mat-paginator>
      </div>
      <div class="text-center no-data-div" *ngIf="noData == true">
        <img src="assets/images/startup-logo.png" class="img-fluid" alt="" />
        <h6>No Records Found</h6>
      </div>
    </div>
  </div>
</section>
